import { SalesRepresentative } from '../../../modules/sales-representative/sales-representative.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import {
  FindSalesRepresentativesOutput,
  FindSalesRepresentativesParams,
  GetSalesRepAvailablePriceTablesOutput,
  GetSalesRepAvailablePriceTablesParams,
  IUpdateSalesRepUserData,
  IUpdateSalesRepUserParams,
} from './salesRepresentatives.types';

const PATH = 'sales-representatives';

export const findSalesRepresentatives = (
  params: FindSalesRepresentativesParams,
  signal?: AbortSignal,
) =>
  restApi.get<FindSalesRepresentativesOutput>(PATH, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const updateSalesRepresentativeUser = (params: IUpdateSalesRepUserParams) =>
  restApi.post<FindSalesRepresentativesOutput>(`${PATH}/${params.salesRepId}/users`, {
    itemIds: params.itemIds,
    userAccessConfig: params.userAccessConfig,
  } as IUpdateSalesRepUserData);

export const getSellerSalesRepresentative = () =>
  restApi.get<SalesRepresentative>(`${PATH}/mine/v1`);

export const getSalesRepAvailablePriceTables = (params: GetSalesRepAvailablePriceTablesParams) =>
  restApi.get<GetSalesRepAvailablePriceTablesOutput>(
    `${PATH}/order/available-price-tables`,
    params,
  );
